import { render, staticRenderFns } from "./teamDetails.vue?vue&type=template&id=e3c1851c&scoped=true&"
import script from "./teamDetails.vue?vue&type=script&lang=js&"
export * from "./teamDetails.vue?vue&type=script&lang=js&"
import style0 from "./teamDetails.vue?vue&type=style&index=0&id=e3c1851c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c1851c",
  null
  
)

export default component.exports